
        var result = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./mini-basemap.component.styl");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/lib/map/baselayers-switcher/mini-basemap.component.styl
// module id = 952
// module chunks = 0